import React from 'react'
import { Button, Form } from 'react-bootstrap'
import { ForgetPassword } from './ForgetPassword'
import routes from 'src/routes'
import { useHistory } from 'react-router'

type LoginFormProps = {
  handleLogin: (e: React.FormEvent) => void
  onEmailInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  onPasswordInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  onAgreeInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  email: string
  password: string
  isFetching: boolean
}

export function LoginForm({
  handleLogin,
  onEmailInput,
  onPasswordInput,
  onAgreeInput,
  email,
  password,
  isFetching,
}: LoginFormProps) {
  const history = useHistory()

  const registerLink = () => {
    history.push(routes.register)
  }
  return (
    <Form onSubmit={handleLogin}>
      <Form.Group>
        <Form.Label>Agent Code</Form.Label>
        <input className="form-input" type="email" value={email} onChange={onEmailInput} />
      </Form.Group>
      <Form.Group>
        <Form.Label>Passcode</Form.Label>
        <input className="form-input border-red-500" type="password" value={password} onChange={onPasswordInput} />
      </Form.Group>

      <div className="helper">
        <ForgetPassword />
        <p style={{ textAlign: 'center' }}>
          For new participant{' '}
          <span
            onClick={registerLink}
            role="button"
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            Register here
          </span>
        </p>
      </div>
      {/* <Form.Group>
                        <label className="d-flex flex-row align-items-start mt-4">
                          <input id="agree" type="checkbox" className="mr-2" value={agree} onChange={onAgreeInput} />
                          <div className="desc">
                            I hereby acknowledge that I have read and understood this{' '}
                            <Link to="/Privacy Notice for Participants.pdf" target="_blank">
                              Personal Data Protection Privacy Notice.
                            </Link>{' '}
                            By checking this box, I acknowledge agreeing to the registration terms and conditions as well as consent to the processing of my
                            personal data in accordance with the terms of this privacy notice.
                          </div>
                        </label>
                      </Form.Group> */}

      <div className="btn-container d-flex justify-content-center mx-auto mt-4">
        <Button type="submit" disabled={!(email.length && password.length) || isFetching} onClick={handleLogin}>
          <span className="d-block font-weight-bold">{isFetching ? 'Loading...' : 'Login'}</span>
        </Button>
      </div>
    </Form>
  )
}
